<div class="div" *ngIf="d">

    <qp-element-info [data]="d" [light]="light" [showDescription]=true [showType]=showType [showUpdated]=true></qp-element-info>

    <!-- <p></p>
    
    <h4 class="mat-subheading-1">{{ data.tag | titlecase }}</h4> -->
    <!-- <mat-list dense> -->

        <!-- { k: 'Description',         v: d.description            | titlecase }, -->

    <qp-table-data *ngIf="d" [nullValues]=true [data]="
        [
            showName
                ? { k: 'Name',                v: d.name                   | titlecase }
                : undefined,
            { k: 'Type',                      v: d.type                   | titlecase },
            showTestProfile
                ? { k: 'Profile id',          v: d.testprofileId                      }
                : undefined,
            showTestProfile
                ? { k: 'Profile description', v: d.testprofileDescription | titlecase }
                : undefined,
            { k: 'Start',                     v: d.startI | datetime                  },
            { k: 'End',                       v: d.endI | datetime                    },
            (d.duration !== undefined)
                ? { k: 'Duration',            v: d.duration | durationsecs            }
                : undefined,
        ]">
    </qp-table-data>

</div>